import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { DataReliabilityPageTab } from '@verantos-dev/core-enums';

import DataReliabilityAccuracyPage from '../containers/DataReliabilityAccuracyPage';
import DataReliabilityPageHeader from '../containers/DataReliabilityPageHeader';

export const DataReliabilityPage = () => {
  const [searchParams] = useSearchParams();
  const activePageTab = searchParams.get('pageTab');
  return (
    <Box>
      <DataReliabilityPageHeader />
      {DataReliabilityPageTab.accuracy === activePageTab && <DataReliabilityAccuracyPage />}
    </Box>
  );
};
